import { Component, OnInit } from '@angular/core';
import { Customer } from 'src/app/models/Customer';
import { ApiService } from 'src/app/services/api.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { LangEnum } from 'src/app/models/LangEnum';
declare const $: any;

@Component({
  selector: 'app-customer-management',
  templateUrl: './customer-management.component.html',
  styleUrls: ['./customer-management.component.css']
})
export class CustomerManagementComponent implements OnInit {

  customers = new Array<Customer>();
  customersIds = new Array<number>();
  selectedId: number;
  isDisabled = true;
  newCustomer = new Array<Customer>();
  constructor(private service: ApiService) { }

  ngOnInit() {
    this.getCustomers();
  }
  async getCustomers() {
    $(".loader").addClass("flex-center");
    this.customers = await this.service.getCustomers(false);

    // Recupero gli id dei clienti per ciclarli
    this.customersIds = this.customers.sort((a, b) => {
      return a.posizione - b.posizione;
    }).map(a => a.idCustomer);

    // Faccio un disctinct degli id per ciclare senza duplicati
    this.customersIds = this.customersIds.filter((thing, i, arr) => arr.findIndex(t => t === thing) === i);

    $(".loader").removeClass("flex-center");
  }
  getCustomerById(id: number) {
    if (id)
      return this.customers.filter(a => a.idCustomer == id);
    else
      return this.newCustomer;
  }
  showModalEdit(id: number) {
    this.selectedId = id;
    $('.modal-customer').modal('show');
  }
  openModalCreate() {
    this.selectedId = null;
    this.newCustomer = new Array<Customer>();
    this.newCustomer[0] = new Customer();
    this.newCustomer[1] = new Customer();
    this.newCustomer[0].lang = LangEnum.EN;
    this.newCustomer[1].lang = LangEnum.IT;
    this.newCustomer[0].posizione = this.customersIds.length + 1;
    this.newCustomer[1].posizione = this.customersIds.length + 1;
    $('.modal-customer').modal('show');
  }
  async update() {
    await this.service.updateCustomers(this.selectedId, this.getCustomerById(this.selectedId));
    this.getCustomers();
  }
  getFlag(lang?: string) {
    return "./assets/img/" + lang + "_flag.svg"
  }
  showModalDelete(id: number) {
    this.selectedId = id;
    $('.delete-customer').modal('show');
  }
  async deleteCustomer() {
    await this.service.deleteCustomers(this.selectedId);
    this.getCustomers();
  }
  async removeImage(id: number) {
    for (let c of this.getCustomerById(id)) {
      c.image = null;
    }
    await this.service.updateCustomers(id, this.getCustomerById(id));
    this.getCustomers();
  }

  async saveImage(id: number) {
    let file = document.getElementById('fileCustomer') as any;
    await this.service.uploadImageCustomer(id, file.files);
    this.getCustomers();
  }

  getImage(c: Customer) {
    if (c.image)
      return './assets/img/clienti/' + c.image;
    return './assets/img/clienti/' + c.idCustomer + '.jpg';
  }
  showModalImage(id: number) {
    this.selectedId = id;
    $('.image-customer').modal('show');
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    console.log('lista', this.customersIds)
  }
  async saveOrdering() {
    this.isDisabled = true;
    await this.service.updateOrderingCustomers(this.customersIds);
    this.getCustomers();
  }
  save() {
    if (this.selectedId) {
      this.update();
    } else {
      this.create();
    }
  }
  async create() {
    await this.service.createCustomers(this.newCustomer);
    this.getCustomers();
  }
}
